/**
 * Clipboard write that works outside secure contexts. `navigator.clipboard` exists
 * only on https/localhost, so plain-http dev hosts (e.g. dev-box over Tailscale)
 * need the legacy `execCommand("copy")` path; the modern API can also reject at
 * runtime (document unfocused, permission denied), which falls back the same way.
 *
 * @returns whether the text landed on the clipboard
 */
export async function copyToClipboard(text: string): Promise<boolean> {
	if (navigator.clipboard) {
		try {
			await navigator.clipboard.writeText(text);
			return true;
		} catch {
			// fall through to the legacy path
		}
	}
	const ta = document.createElement("textarea");
	ta.value = text;
	ta.style.position = "fixed";
	ta.style.opacity = "0";
	document.body.appendChild(ta);
	ta.select();
	try {
		return document.execCommand("copy");
	} catch {
		return false;
	} finally {
		ta.remove();
	}
}
